import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import BasicLink from './BasicLink';
import LinkButton from './LinkButton';
import Icon from './Icon/Icon';
import { doi as getLinkToDoi } from '../utils/identifier-url';
import { showFullText } from '../actions/document';

const LINK_TYPE = 'link';

function FullTextButton(props) {
  const {
    doc,
    children,
    type = LINK_TYPE,
    className,
    fluid,
    track,
    currentPage,
    position,
    isSuggested,
  } = props;

  const doi = doc.identifiers && doc.identifiers.doi;

  if (!doi) {
    return null;
  }

  const isButton = type !== LINK_TYPE;

  const Button = isButton ? LinkButton : BasicLink;

  return (
    <Button
      to={getLinkToDoi(doi)}
      target="_blank"
      external
      data-name="open-full-text"
      className={className}
      fluid={isButton ? fluid : undefined}
      buttonStyle={isButton ? 'secondary' : undefined}
      withIcon
      track={track ? { ...track, action: 'OpenFullText', value: { documentId: doc.id } } : {}}
      onClick={() => props.showFullText({
        doc,
        currentPage,
        position,
        isSuggested,
      })}
    >
      <Icon name="external-link" />
      <span>{ children }</span>
    </Button>
  );
}

FullTextButton.propTypes = {
  doc: PropTypes.object.isRequired,
  track: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
  showFullText,
};

export default connect(null, mapDispatchToProps)(FullTextButton);



// WEBPACK FOOTER //
// ./src/universal/ui/components/FullTextButton.js